import { SubscriptionInvitation } from "../models/subscription-invitation";
import { ReturnCurrentUserDelegationCommand } from "../models/return-current-user-delegation-command.model";

export namespace SubscriptionsActions {
    export class GetActiveAndPendingSubscriptions {
        public static readonly type = "[Subscriptions] GetInvitations";
    }

    export class AnswerInvitation {
        public static readonly type = "[Subscriptions] AnswerInvitation";
        constructor(
            public identityUserId: string,
            public subscriptionInvitation: SubscriptionInvitation,
            public signature: string,
            public accept: boolean,
        ) {}        
    }

    export class ReturnCurrentUserDelegation {
        public static readonly type = "[Subscriptions] ReturnCurrentUserDelegation";
        constructor(public command: ReturnCurrentUserDelegationCommand) {}
    }
}
